<template>
  <div class="overlay">
    <div class="onboarding-team-skip-modal">
      <img src="@/assets/images/onboarding_team_skip_modal.png" class="background-img" alt="background-img" />
      <div class="modal-content">
        <div class="modal-title">
          Are you sure you want to skip?
        </div>
        <div class="modal-description">
          Adding a team unlocks a ton of features, like:
        </div>
        <div v-for="(feature, index) in features" :key="index" class="modal-feature">
          <img src="@/assets/images/check.png" class="feature-check" alt="check" />
          {{ feature }}
        </div>
        <div class="modal-buttons-row">
          <custom-button
            customStyle="width: 230px; background-color: #FFFFFF; border: 1px solid #008619; color: #008619;"
            :onClick="onBack"
          >
            Take me back
          </custom-button>
          <custom-button customStyle="margin-left: 5px; flex: 1;" :onClick="onNext">
            Yes I’m sure
          </custom-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomButton from '@/components/CustomButton';

export default {
  name: 'OnboardingTeamSkipModal',
  components: { CustomButton },
  props: {
    onBack: Function,
    onNext: Function
  },
  data() {
    return {
      features: [
        'Call routing (e.g. to departments or extensions)',
        'Text message routing based on keywords',
        'Collaboration and oversight'
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.onboarding-team-skip-modal {
  position: relative;
  width: 650px;
  height: 620px;
  background-color: $colorBack;
  border-radius: 10px;

  .background-img {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
  }

  .modal-content {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    display: flex;
    flex-direction: column;
    padding: 0 35px;
  }

  .modal-title {
    width: 446px;
    margin-top: 218px;
    font-weight: 800;
    font-size: 40px;
    line-height: 48px;
    letter-spacing: -0.5px;
    color: $colorTitle;
  }

  .modal-description {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.1px;
    color: $colorText;
    margin-top: 25px;
    margin-bottom: 10px;
  }

  .modal-feature {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.1px;
    color: $colorText;
    margin-top: 5px;

    .feature-check {
      width: 17px;
      // height: 17px;
      margin-right: 16px;
    }
  }

  .modal-buttons-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: absolute;
    bottom: 30px;
    width: calc(100% - 70px);
  }
}
</style>
